import React from 'react';
import { useAdminAccess } from '../../hooks/useAdminAccess';
import AccessDenied from './AccessDenied';

interface AdminRouteProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

const AdminRoute: React.FC<AdminRouteProps> = ({
  children,
  requireSuperAdmin = false,
}) => {
  const { isSuperAdmin, isCognitoAdmin, hasAnyAdminRole } = useAdminAccess();

  if (requireSuperAdmin && !isSuperAdmin()) {
    return <AccessDenied message="This page requires super admin access." />;
  }

  if (!hasAnyAdminRole()) {
    return <AccessDenied message="This page requires admin access." />;
  }

  return <>{children}</>;
};

export default AdminRoute;
